import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { successfulUpdate } from '@/helpers/mixins/LocalizationHelper';
import categoryUpdate from '@/plugins/graphql/mutations/category-update.gql';
import CategoryFormMixin from '@/helpers/vue_mixins/v2/ecommerce/CategoryFormMixin';
import CategoryImageUploadMixin from '@/helpers/vue_mixins/v2/ecommerce/CategoryImageUploadMixin';
import DiyMixin from '@/helpers/vue_mixins/v2/DiyMixin';
import InquirySubCategoryFormMixin from '@/helpers/vue_mixins/v2/inquiry/InquirySubCategoryMixin';
import CategoryFragment from '@/plugins/graphql/fragments/category.gql';
import { isNotEmpty } from '@/helpers';
import { FileUploadInputModel } from '@/helpers/entities/models/FileUploadInputModel';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let CategoryUpdateMixin = class CategoryUpdateMixin extends mixins(CategoryFormMixin, CategoryImageUploadMixin, DiyMixin, InquirySubCategoryFormMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.name = '';
        this.description = '';
    }
    get categoryUuid() {
        return this.uuid || this.category.uuid;
    }
    get queryOnFlight() {
        return this.$apollo.queries.category.loading;
    }
    buildEcommerceFormData(category) {
        const data = {
            name: null,
            description: null,
            subcategories: [],
            images: [],
            brandUuid: '',
        };
        if (category) {
            const { name, description, subcategories, photos } = category;
            const images = photos.map((photo) => new FileUploadInputModel(photo));
            return {
                name,
                description,
                subcategories,
                images,
                brandUuid: category.categorizableUuid,
            };
        }
        return data;
    }
    async onSubmit(form) {
        this.requestOnFlight();
        await this.update(form)
            .then(async () => {
            if (this.hasMatches(form.subcategories.length)) {
                await this.sendSubCategoryMutations(this.categoryUuid, form.subcategories);
            }
            const { inquirySubcategories } = form;
            if (inquirySubcategories && this.hasMatches(inquirySubcategories.length)) {
                await this.sendInquirySubCategoryMutations(this.categoryUuid, inquirySubcategories);
            }
            const newImages = this.filterNewImages(form.images);
            if (isNotEmpty(newImages.length)) {
                await this.uploadImages(this.categoryUuid, newImages);
            }
            const deletedImagesUuids = this.getDeletedImageUuids(form.images);
            if (isNotEmpty(deletedImagesUuids.length)) {
                await this.removeImages(this.categoryUuid, deletedImagesUuids);
            }
            if (!this.diy) {
                const msg = successfulUpdate(this.moduleName);
                this.successNotification(msg);
            }
            if (this.diy) {
                this.onNext();
            }
            else {
                this.goToCategoriesPage();
            }
            this.productCategoryAction('SUBMIT EDIT');
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async update(form) {
        const { moduleName } = this;
        const { categoryUuid } = this;
        return this.$apollo.mutate({
            mutation: categoryUpdate,
            variables: {
                input: {
                    name: form.name,
                    description: form.description,
                    categoryUuid,
                    brandUuid: form.brandUuid,
                },
            },
            update(cache, result) {
                const { data: { categoryUpdate: { category }, }, } = result;
                cache.writeFragment({
                    id: categoryUuid,
                    fragment: CategoryFragment,
                    data: category,
                    fragmentName: moduleName,
                });
            },
        });
    }
};
__decorate([
    Prop({ type: String, required: true })
], CategoryUpdateMixin.prototype, "uuid", void 0);
CategoryUpdateMixin = __decorate([
    Component({})
], CategoryUpdateMixin);
export default CategoryUpdateMixin;
